var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ticket-history" } },
    [
      _c(
        "b-row",
        { attrs: { id: "visitor-history-row" } },
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-1 custom-input",
                  attrs: {
                    id: "start-date-input-group",
                    label: _vm.$t("message.first"),
                    "label-for": "start-date-input",
                    "label-sr-only": "",
                  },
                },
                [
                  _c("datetime", {
                    attrs: {
                      "max-datetime": _vm.maxDate,
                      "min-datetime": _vm.lastFiveYear,
                      phrases: _vm.phrases,
                      placeholder: _vm.$t("message.startDate"),
                      auto: "",
                      "input-class": "form-control rounded-0",
                      "input-id": "start-date-input",
                      type: "datetime",
                    },
                    model: {
                      value: _vm.queries.dateBegin,
                      callback: function ($$v) {
                        _vm.$set(_vm.queries, "dateBegin", $$v)
                      },
                      expression: "queries.dateBegin",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-1 custom-input",
                  attrs: {
                    id: "end-date-input-group",
                    label: _vm.$t("message.last"),
                    "label-for": "end-date-input",
                    "label-sr-only": "",
                  },
                },
                [
                  _c("datetime", {
                    attrs: {
                      "max-datetime": _vm.maxDate,
                      "min-datetime": _vm.lastFiveYear,
                      phrases: _vm.phrases,
                      placeholder: _vm.$t("message.endDate"),
                      auto: "",
                      "input-class": "form-control rounded-0",
                      "input-id": "end-date-input",
                      type: "datetime",
                    },
                    model: {
                      value: _vm.queries.dateEnd,
                      callback: function ($$v) {
                        _vm.$set(_vm.queries, "dateEnd", $$v)
                      },
                      expression: "queries.dateEnd",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-1 custom-input",
                  attrs: {
                    id: "query-input-group",
                    label: _vm.$t("message.query"),
                    "label-for": "query-input",
                    "label-sr-only": "",
                  },
                },
                [
                  _c("b-form-input", {
                    staticClass: "rounded-0",
                    attrs: {
                      id: "query-input",
                      placeholder: _vm.$t("message.query"),
                      name: "query",
                    },
                    model: {
                      value: _vm.queries.query,
                      callback: function ($$v) {
                        _vm.$set(_vm.queries, "query", $$v)
                      },
                      expression: "queries.query",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "custom-input" },
            [
              _c("a-rate", {
                attrs: { "allow-clear": true },
                model: {
                  value: _vm.queries.rate,
                  callback: function ($$v) {
                    _vm.$set(_vm.queries, "rate", $$v)
                  },
                  expression: "queries.rate",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                { staticClass: "mb-1 custom-input" },
                [
                  _c(
                    "b-form-select",
                    {
                      staticClass: "mb-3",
                      model: {
                        value: _vm.queries.assignedUser,
                        callback: function ($$v) {
                          _vm.$set(_vm.queries, "assignedUser", $$v)
                        },
                        expression: "queries.assignedUser",
                      },
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("message.allUsers")) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.usersFilter.data, function (item) {
                        return _c(
                          "option",
                          { key: item._id, domProps: { value: item._id } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(item.name) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ArchiveComponent", {
        attrs: {
          "hide-filters": true,
          "is-archive": false,
          "selected-time": _vm.timeSelect,
          "table-data": _vm.ticketHistory.tickets.map(function (x) {
            return Object.assign({}, x, {
              fullname: !!x.osrPayload
                ? x.osrPayload["fullname"]
                : !!x.conversation
                ? x.conversation["fullname"]
                : "-",
              email: !!x.osrPayload
                ? x.osrPayload["email"]
                : !!x.conversation
                ? x.conversation["email"]
                : "-",
              phone: !!x.osrPayload
                ? x.osrPayload["phone"]
                : !!x.conversation
                ? x.conversation["phone"]
                : "-",
            })
          }),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }